import './App.css';
import Container from './components/Container/Container';
import Header from './components/Header/Header';



function App() {
  return (
    <div>
      <Header></Header>
      <Container></Container>
    </div>
  );
}

export default App;
